module.exports = __webpack_public_path__ + "static/media/pf3.224e4fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf3.png
// module id = 2663
// module chunks = 0